import getApiUrl from "../utils/apiUrl";
import fetch from "../utils/mgFetch";

const getOffer = (token: string, backend: string, id) => {
    return fetch(`${getApiUrl(backend)}offers/${id}`, {
        method: "GET",
        headers: {
            Authorization: `Bearer ${token}`
        }
    }) 
}

export default getOffer